export const values = [
  {
    id: 'empowerment',
    title: 'Empowerment',
    description: 'We believe everyone has the power to design their own path.',
    icon: 'Sparkles'
  },
  {
    id: 'community',
    title: 'Community',
    description: 'Success is sweeter when we lift each other up.',
    icon: 'Users'
  },
  {
    id: 'wellbeing',
    title: 'Well-Being',
    description: 'Sustainable success starts with taking care of yourself.',
    icon: 'Heart'
  },
  {
    id: 'inclusion',
    title: 'Inclusion',
    description: 'STEAM is for everyone, and everyone belongs here.',
    icon: 'Globe'
  },
  {
    id: 'innovation',
    title: 'Innovation',
    description: 'We challenge conventional thinking and embrace new approaches.',
    icon: 'Lightbulb'
  }
];

export const services = [
  {
    id: 'mentorship',
    title: 'Mentorship & Career Mapping',
    description: 'Personalized guidance to help you navigate your unique STEAM career trajectory. Together, we\'ll map your skills, interests, and opportunities.',
    icon: 'Compass',
    link: '/consulting'
  },
  {
    id: 'wellness',
    title: 'Wellness & Mindfulness',
    description: 'Integrate sustainable self-care practices into your demanding career. Prevent burnout and enhance creativity through mindfulness.',
    icon: 'Leaf',
    link: '/courses'
  },
  {
    id: 'balance',
    title: 'Career & Family Balance',
    description: 'Real strategies for balancing professional ambition with personal life. You don\'t have to choose between your STEM career and your family.',
    icon: 'Scale',
    link: '/courses'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Chen',
    role: 'Software Engineer at Google',
    quote: 'Diana helped me see my career in a completely new way. I was stuck in a narrow path, but now I\'m exploring opportunities I never knew existed.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=150'
  },
  {
    id: 2,
    name: 'Marcus Johnson',
    role: 'Biotech Researcher',
    quote: 'The wellness program saved my career. I was on the verge of burnout, and Diana\'s approach helped me rebuild sustainable habits.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=150'
  },
  {
    id: 3,
    name: 'Elena Rodriguez',
    role: 'Engineering Manager',
    quote: 'As a working mom in tech, I felt alone. STEMJECTORY\'s community showed me that balance is possible, and I\'m not alone in this journey.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=150'
  }
];
